import { useEffect } from 'react';
import { toBrDateWithTime } from '../../../../../utils/dateUtils';
import styles from '../../pa_checklist_followup.module.scss';
import { usePAChecklistFollowUp } from '../../pa_checklist_followup_context';

const TabInfoComp = () => {
  const { itemSelecionado } = usePAChecklistFollowUp();

  const itemRenderer = (label, value) => {
    return (
      <span className={styles.info_label}>{label}<div className={styles.info_value}>{value}</div></span>
    );
  }

  const statusList = {
    4: { label: '04 - APROVADO', color: '#B4E380' },
    5: { label: '05 - APROVADO COM RESTRIÇÕES', color: '#F6FB7A' },
    7: { label: '07 - DEVOLUÇÃO PARCIAL', color: '#F6FB7A' },
    6: { label: '06 - DEVOLUÇÃO TOTAL', color: '#FF7777' },
    8: { label: '08 - REPROVADO NA PROVA DE ROUPA', color: '#FFBABA' },
  };

  const statusRenderer = (label, value, idStatus) => {
    return (
      <span className={styles.info_label}>
        {label}
        <div
          className={styles.info_value}
          style={{ padding: '0px 6px', borderRadius: '4px', backgroundColor: statusList[idStatus]?.color || 'FFF', width: 'fit-content' }}
        >
          {value}
        </div>
      </span>
    )
  }

  const isNull = (value) => {
    if (value === null) return true;
    return false;
  }

  return (
    <section className={styles.info_tab_comp_wrapper}>
      <div className={styles.info_tab_comp_inner}>
        <span className={styles.info_value} style={{ width: '100%' }}>
          {itemSelecionado.filial_revisao} | {itemSelecionado.marca} | {toBrDateWithTime(itemSelecionado.data_registro)}
        </span>
        <div className={styles.info_tab_comp}>
          {/* Revisão */}
          {itemRenderer('Data Revisão:', toBrDateWithTime(itemSelecionado.data_revisao))}
          {itemRenderer('Usuário Revisão:', itemSelecionado.usuario_responsavel_revisao)}
          {statusRenderer('Status Revisão:', itemSelecionado.status_revisao, itemSelecionado.id_status_revisao)}
          {itemRenderer(
            'Preço Divergente?',
            isNull(itemSelecionado?.resultadoRevisao?.preco_tag_divergente) ? '-' :
              itemSelecionado?.resultadoRevisao?.preco_tag_divergente ? 'Sim' : 'Não'
          )}
          {itemRenderer(
            'Composição Divergente?',
            isNull(itemSelecionado?.resultadoRevisao?.composicao_tag_divergente) ? '-' :
              itemSelecionado?.resultadoRevisao?.composicao_tag_divergente ? 'Sim' : 'Não'
          )}
        </div>

        <div className={styles.separator} />

        <div className={styles.info_tab_comp}>
          {/* Análise Checklist */}
          {itemRenderer('Data Análise', toBrDateWithTime(itemSelecionado.data_analise) || '-')}
          {itemRenderer('Usuário Análise', itemSelecionado.usuario_responsavel_analise || '-')}
          {itemRenderer('Costura com fio?', isNull(itemSelecionado.costura_com_fio) ? '-' : itemSelecionado.costura_com_fio ? 'Sim' : 'Não')}
          {itemRenderer('Gradação Realizada?', isNull(itemSelecionado.gradacao_realizada) ? '-' : itemSelecionado.gradacao_realizada ? 'Sim' : 'Não')}
          {itemRenderer('Zíper inisível?', isNull(itemSelecionado.ziper_invisivel) ? '-' : itemSelecionado.ziper_invisivel ? 'Sim' : 'Não')}
          {itemRenderer('Avaliação c/ Piloto?', isNull(itemSelecionado.possui_peca_piloto) ? '-' : itemSelecionado.possui_peca_piloto ? 'Sim' : 'Não')}
           {itemRenderer(
            'Preço Divergente?',
            isNull(itemSelecionado?.resultadoCaixa?.preco_tag_divergente) ? '-' :
              itemSelecionado?.resultadoCaixa?.preco_tag_divergente ? 'Sim' : 'Não'
          )}
          {itemRenderer(
            'Composição Divergente?',
            isNull(itemSelecionado?.resultadoCaixa?.composicao_tag_divergente) ? '-' :
              itemSelecionado?.resultadoCaixa?.composicao_tag_divergente ? 'Sim' : 'Não'
          )}
        </div>

        <div className={styles.separator} />
        <div className={styles.info_tab_comp}>
          {/* Prova de Roupa */}
          {itemRenderer('Data Prova de Roupa', toBrDateWithTime(itemSelecionado.data_prova_de_roupa) || '-')}
          {itemRenderer('Usuário Prova de Roupa', itemSelecionado.usuario_responsavel_prova_de_roupa || '-')}
          {statusRenderer('Status Prova de Roupa', itemSelecionado.status_prova_roupa || '-', itemSelecionado.id_status_prova_de_roupa)}
          {itemRenderer('Observação Prova de Roupa', itemSelecionado.observacao_prova_de_roupa || '-')}
        </div>

        <div className={styles.separator} />
        <div className={styles.info_tab_comp}>
          {/* Finalização */}
          {itemRenderer('Data Finalização', toBrDateWithTime(itemSelecionado.data_finalizacao) || '-')}
          {itemRenderer('Usuário Finalização', itemSelecionado.usuario_responsavel_finalizacao || '-')}
          {statusRenderer('Status Final', itemSelecionado.status_final || '-', itemSelecionado.id_status_final)}
          {itemRenderer('Movimentado', isNull(itemSelecionado.movimentado) ? '-' : itemSelecionado.movimentado ? 'Sim' : 'Não')}
          {itemRenderer('Indica Culpabilidade do Forn.', itemSelecionado.indica_culpabilidade ? 'Sim' : 'Não')}
          {itemRenderer('Pendente', isNull(itemSelecionado.pendente) ? '-' : itemSelecionado.pendente ? 'Sim' : 'Não')}
          {itemRenderer('Data Pendenciamento', toBrDateWithTime(itemSelecionado.data_pendenciamento) || '-')}
          {itemRenderer('Usuário Pendenciamento', itemSelecionado.usuario_responsavel_pendenciamento || '-')}
          {itemRenderer('Atribuicao Pendencia', itemSelecionado.atribuicao_pendencia || '-')}
          {itemRenderer('Justificativa Pendencia', itemSelecionado.justificativa_pendencia || '-')}
          {itemRenderer('Responsável Estilo', itemSelecionado.responsavel_analise_pendencia || '-')}
        </div>
      </div>

      <div className={styles.separator} />

      <div className={styles.info_tab_comp}>
        {itemRenderer('Ordem Produção:', itemSelecionado.ordem_producao)}
        {itemRenderer('Segunda Qualidade? ', itemSelecionado.nf_segunda_qualidade ? 'Sim' : 'Não')}
        {itemRenderer('Nota Fiscal:', itemSelecionado.nf_entrada)}
        {itemRenderer('Série:', itemSelecionado.serie_nf)}
        {itemRenderer('Origem:', itemSelecionado.origem)}
        {itemRenderer('Marca', itemSelecionado.marca)}
        {itemRenderer('Produto:', itemSelecionado.produto)}
        {itemRenderer('Descrição Produto:', itemSelecionado.descricao_produto)}
        {itemRenderer('Cor Produto:', itemSelecionado.cor_produto)}
        {itemRenderer('Descrição Cor:', itemSelecionado.descricao_cor)}
        {itemRenderer('Qtde. Entrada:', itemSelecionado.qtde_entrada)}
      </div>
    </section>
  );
}

export default TabInfoComp;
